<ng-template #sessionExpiry let-modal>
    <div class="modal-content">
      <div class="modal-header">
        <div class="mng-qualifier-header-popup" id="SessionExpiryInfo">{{'session_expiry_popup_header_message' | translate}}</div>
      </div>
      <div class="info-s">
        <p>{{'session_expiry_popup_notice_msg1'|translate}}  <span class="highlight">{{minutes}}:{{seconds|number: '2.0'}} </span> {{'minutes'|translate }}. {{'session_expiry_popup_notice_msg2'|translate}}.</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="buttons" (click)="modal.dismiss('Cross click')">{{'Continue'|translate}}</button>
      </div>
    </div>
  </ng-template>
